export default __webpack_public_path__ + "static/media/download_hover.ee6f115b.svg";